/**
 * Created by lihanying on 2017/7/6.
 */

export const GETPERMISSION = 'GETPERMISSION'
export const GETCLUBLISTSUCCESS = 'GETCLUBLISTSUCCESS'
export const GETCLUBINFO = 'GETCLUBINFO'
export const GETWALLETINFO = 'GETWALLETINFO'
export const GETWALLETRECORD = 'GETWALLETRECORD'


// WEBPACK FOOTER //
// ./src/containers/ClubList/constants.js